import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../Widgets/LabeledText";
import { FamilyHistoryFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: FamilyHistoryFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText label="Caregiver main concerns" value={formValues.caregiverMainConcerns} />

      <LabeledText label="Daily Routine and structure" value={formValues.dailyRoutineStructure} />

      <LabeledText
        label="Family and caregivers present in the home and others involved in care"
        value={formValues.familyCaregiversInHome}
      />
    </Grid>
  );
};

export default ViewFields;
